module.exports = __webpack_public_path__ + "img/0ac249b5b99bf48c3b4f5566eaae5481.png";